import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const DateFilter = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.SELECTED_DATE_FILTER:
      return { ...state, selectedDateFilter: action.value };
    default:
      return state;
  }
};
export default DateFilter;
